import {ActivatedRoute} from "@angular/router";
import {IAuthenticationPublicWebServiceClient, TokenDto} from "./../../../../common/resources/auth/resources.auth";
import {AsiFileService} from "@asi-ngtools/lib";
import {Component} from "@angular/core";

@Component({
  selector: 'document-telechargement',
  templateUrl: './document-telechargement.component.html',
  host: {'class': 'page'}
})
export class DocumentTelechargementComponent {

  token: TokenDto;

  constructor(private fileUtils: AsiFileService, pageTokenWebService: IAuthenticationPublicWebServiceClient, activatedRoute: ActivatedRoute) {
    let pageToken = activatedRoute.snapshot.queryParams["page_token"]

    pageTokenWebService.validateToken({token: pageToken}).subscribe(res => {
      this.token = res;
      if( res.maxUse > -1 &&  res.count > res.maxUse){
        console.log("error useMax");
      }else{
        this.downloadFile(this.token.url);
      }
    })
  }

  downloadFile(url: string) {
    this.fileUtils.getFileAsBlob(this.token.url).subscribe((fileAsBlob) => {
      let fileName = fileAsBlob.name;
      if (!fileName) {
        fileName = "Document.pdf"
      }
      this.saveToFile(fileAsBlob, fileName);
    });
  }

  saveToFile(fileAsBlob: Blob, fileName: string) {
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(fileAsBlob, fileName);
    } else {
      let url = window.URL.createObjectURL(fileAsBlob);
      var anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.target = '_blank';
      anchor.href = url;
      anchor.dispatchEvent(new MouseEvent("click"));
      document.body.removeChild(anchor);
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/document/document-telechargement.component.ts